var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8745 7.01199V9.19686C13.8745 9.33715 14.5983 9.33715 14.5983 9.19686V7.92761C14.5983 7.05877 16.3305 7.05877 16.3305 7.92761L16.3307 17.5H8.28013V15.6646C8.28013 15.6646 4.66406 14.0033 4.66406 13.0074V7.974C4.66406 6.96563 6.56888 6.91881 6.56888 7.974V10.8749C6.56888 11.0273 7.22548 11.0131 7.22548 10.8606V3.15062C7.22548 2.28313 8.97313 2.28313 8.97313 3.15062V9.19709C8.97313 9.33738 9.68069 9.33738 9.68069 9.19709V6.21697C9.68069 5.34813 11.4281 5.34813 11.4281 6.21697V9.19709C11.4281 9.33738 12.1264 9.33738 12.1264 9.19709V7.01221C12.1264 6.14306 13.8744 6.14306 13.8744 7.01206L13.8745 7.01199Z",
    fill: "#0F283E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/Vote.3e824a07d1b9d2a1491a7f8f0023324a.svg";
export { ForwardRef as ReactComponent };